import { SectionSwitcher } from "./SectionSwitcher";
import { countEntities } from "./countEntities";

export const updateTables = async () => {
    return $.ajax({
        url: window.location.href,
        method: 'GET',
        success: (data) => {
            if ($('.wrapper-view .data-tables').length>0) {
                $('.wrapper-view .data-tables').html(data);
                SectionSwitcher.init();
                countEntities();
            } else {
                location.reload(true);
            }
        }
    });
}
